import axios from 'axios';
import { browserHistory } from 'react-router';

import {
  REQUEST_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  CREATE_USER,
  SELECT_USER
} from './type'

const USERS_URL = 'http://jsonplaceholder.typicode.com/users/';

import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI } from './root_url'

export function fetchUsers() {
  return dispatch => {
    dispatch(requestUsers());
    return axios.get(USERS_URL)
      .then(response => {
        dispatch(fetchUsersSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchUsersFailure(err));                       
        }
      });
  }
}

export function requestUsers() {
  return {
    type: REQUEST_USERS,
  };
}

export function fetchUsersSuccess(users) {
  return {
    type: FETCH_USERS_SUCCESS,
    payload: users
  };
}

export function fetchUsersFailure(error) {
  return {
    type: FETCH_USERS_FAILURE,
    payload: error
  };
}

export function createUsers(props) {
  const request = axios.post(USERS_URL, props)
  return {
    type: CREATE_USER,
    payload: request
  };
}

export function selectUser(user) {
  return {
    type: SELECT_USER,
    payload: user
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/users_actions.js